import { defineStore } from 'pinia'

interface ResultState {
  message: string | null
  type: 'ok' | 'ng'
}

/**
 * DB更新を伴う処理(審査ボタン・保存・削除・画像操作等)の完了結果を表示する
 * 画面中央のモーダル。トーストは見落とされやすいため、重要な結果はこちらを使う。
 * リンクコピー等の重要度が低い通知は引き続き stores/toast.ts を使う。
 */
export const useResultModalStore = defineStore('resultModal', {
  state: (): ResultState => ({
    message: null,
    type: 'ok',
  }),
  actions: {
    show(message: string, type: 'ok' | 'ng' = 'ok') {
      this.message = message
      this.type = type
    },
    close() {
      this.message = null
    },
  },
})
